export default __webpack_public_path__ + "static/media/secure-stripe.2b096946.png";